<template>
  <div class="anchor">
    <!-- <k-header :headerData="headerData">
      <span class="live-btn" @click="issueQuestion">发布问卷</span>
      <span v-if="isLive == 0" class="live-btn t-start" @click="startLive">开始</span>
      <span v-if="isLive == 1" class="live-btn t-end" @click="endLive">结束</span>
      <span class="live-btn t-clear" @click="clearCode">清除代码</span>
      <span class="live-btn t-clear" @click="exportCode">导出代码</span>
    </k-header> -->
    <v-header :config="headerData" 
              @startLesson="startLive" 
              @endLesson="endLive" 
              @IQNaire="issueQuestion" 
              @studentQA="askQuestion" 
              @clearEditor="clearCode" 
              @checkCode="checkRole" 
              @exportFile="exportCode">
    </v-header>
    <drag :options="optionData" class="dragwrap">
      <div class="work" slot='uLeft' ref="work">
        <editor ref="myEditor" :isLive="true" :isCheck="check"></editor>
        <div class="qa-wrap" v-show="isShowQA" ref="qaWrap">
          <div class="qa-notice">
            点击学生名字查看代码
          </div>
          <div class="qa-list">
            <div class="qa-item" :class="qaItemActiveIndex == index?'active':''" @click="getItemCode(item); qaItemActiveIndex=index" v-for="(item, index) in qaSet" :key="'qa-' + index">
              <span>{{item.name || '匿名学员'}}</span>
              <i class="icon iconfont icon-guanbi" @click="closeQAItem(index)"></i>
            </div>
          </div>
          <div class="qa-close" @click.stop="closeQAWrap">
            <span>关闭问答</span>
          </div>
        </div>
      </div>
      <div class="work" slot='uRight'>
        <iterm isCompile="1" :options="itermData" :tab="tab" :inputParam="inputParam" :compileInfo="compileInfo" @insertTemplate="insertData"></iterm>
      </div>
    </drag>
    <div class="countdown" v-show="countdown">
     <h1>{{count}}</h1>
    </div>
    <div class="qatip tip-wrap" v-if="qatip">
      <div class="t-header">
        <p>提示</p>
        <p><i class="icon iconfont icon-guanbi" @click="qatip=!qatip"></i></p>
      </div>
      <div class="ti-wrap">
        <p>当前直播窗口为学生窗口，需要将直播窗口切换给老师吗？点击‘切换’将关闭学生窗口。</p>
      </div>
      <div class="tb-wrap">
        <div class="notip">
          <i class="icon iconfont icon-baochi" :class="{activeTip: isActiveTip}" @click="noTip"></i>不再提醒
        </div>
        <div class="">
          <button @click="checkMenu">切换</button>
          <button @click="noCheckMenu">不切换</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
/* eslint-disable */
import Drag from '@/components/Drag'
// import kHeader from '@/components/Header'
import vHeader from '@/components/HeaderV2'
import Editor from '@/components/Editor/editor'
import Iterm from '@/components/ItermV2'
import IO from 'socket.io-client'
import { url } from '@/config/url_config'
import EventBus from '@/views/eventBus'
import { insertTemplate, getFileName, exportFile } from '@/utils/utils'
export default {
  components: {
    Drag,
    // kHeader,
    vHeader,
    Editor,
    Iterm
  },
  data () {
    return {
      optionData: {
        layout: 'u-d'
      },
      headerData: {
        role: 1,
        roomId: this.$route.params.roomId,
        number: '0',
        isLive: false,
        qaTime: false,
        isQA: false,
        nameQA: '',
        forceChangeQAIndex: 0
      },
      itermData: {
        isCompile: true,
        isLive: true
      },
      tab: 0,
      inputParam: '',
      compileInfo: {},
      isLive: 0,
      countdown: false,
      count: 3,
      isShowQA: false,
      qaSet: [],
      qatip: false,
      qaItemActiveIndex: -1,
      isTip: true,
      isActiveTip: false,
      n: 'one',           // 切换到学生代码 
      check: 'live',      // 切换到直播
      isGetCode: true     // 是否获取页面代码
    }
  },
  created () {
  },
  mounted () {
    this.initSocket()
    this.editor.on('change', function(instance, changeObj){
      console.log(changeObj)
    })
    
    EventBus.$on('closeQAMenu', () => {
      if (this.isTip) {
        this.qatip = true
      } else {
        // this.headerData.isQA = false
        this.checkMenu()
      }
    })
  },
  computed: {
    editor() {
      return this.$refs.myEditor.editor
    }
  },
  methods: {
    initEditor() { 
    },
    startLive () {
      let _this = this

      _this.countdown = true
      _this.isLive = 1

      _this.socket.emit('start.live', this.$route.params.roomId)
      console.log(this.$route.params.roomId)
      // _this.socket.emit('start.live')
      // 倒计时
      var countdown = setInterval(function () {
        console.log(_this.count)
        _this.count--
        if (_this.count === -1) {
          _this.countdown = false
          clearInterval(countdown)
          _this.count = 3
          // _this.socket.emit('sync.programming')
        }
      }, 1000)
    },
    endLive () {
      console.log('classRoom')
      // let socket = IO(url)
      this.isLive = false
      this.socket.emit('clear.editor', this.$route.params.roomId)
      this.$router.push({name: 'ClassRoom'})
    },
    initSocket () {
      let _this = this
      // let userInfo = {
      //   roomId: _this.$route.params.roomId,
      //   userName: '老师',
      //   role: 'teacher'
      // }
      _this.socket.on('connect', function () {
        console.log('connect')
        _this.editor.setValue(localStorage.getItem('editorContent') || '')
      })
      // _this.socket.emit('join.room', userInfo)

      _this.socket.on('student.number', function (data) {
        console.log('student.number==========:', data)
        _this.headerData.number = data || '0'
      })

      _this.socket.on('teacher.room.data', function (data, id) {
        console.log('teacher.room.data:', data)
        window.localStorage.setItem('roomData', data)
        _this.headerData.number = data.number || '0'
      })

      _this.socket.on('student.qa', function (data) {
        console.log('student.qa:', data)
        _this.qaSet.push(data)
      })
    },
    clearCode() {
      this.editor.setValue('')
      EventBus.$emit('clearResult')
      this.$store.commit('clearCode', '')
      this.socket.emit('compile.result', '', this.headerData.roomId)
    },
    insertData(language) {
      insertTemplate(language, this.editor)
    },
    exportCode() {
      var content = this.editor.getValue()
      var languageId = this.$route.params.languageId
      var filename = getFileName(languageId)
      exportFile(content, filename)
    },
    issueQuestion() {
      console.log('999999')
      EventBus.$emit('showQuestionPanel')
    },
    askQuestion() {
      let _this = this
      this.isShowQA = !this.isShowQA
      let work = this.$refs.work
      let height = 0
      this.$nextTick(function(){
          let qaWrapHeight = _this.$refs.qaWrap.clientHeight
          if (_this.isShowQA) {
            let time = setInterval(function(){
              work.style.height = "calc(100% - " + height +"px)"
              height += 10
              if (height >= qaWrapHeight) {
                work.style.height = "calc(100% - " + qaWrapHeight +"px)"
                clearInterval(time)
              }
            }, 10)
          } else {
            work.style.height = "100%"
          }
      })
    },
    closeQAWrap() {
      this.askQuestion()
    },
    getItemCode(item) {
      console.log(this.editor.getValue())
      let editorCode = this.editor.getValue()
      let teacherCode = sessionStorage.getItem('teacherCode')

      if (this.isGetCode) {
        sessionStorage.setItem('teacherCode', editorCode)
        this.isGetCode = false
      }

      this.headerData.forceChangeQAIndex++
      this.headerData.isQA = true
      this.headerData.qaTime = true
      this.headerData.nameQA = item.name || '匿名学员'
      this.editor.setValue(item.code)
    },
    noTip() {
      this.isTip = false
      this.isActiveTip = !this.isActiveTip
    },
    checkMenu() {
      this.headerData.isQA = false
      this.headerData.qaTime = false
      this.qatip = false
      this.isGetCode = true

      let teacherCode = sessionStorage.getItem('teacherCode')
      console.log('teacherCode', teacherCode)
      this.editor.setValue(teacherCode)
    },
    noCheckMenu() {
      this.qatip = false
    },
    checkRole(index) {
      if (!index) {
        sessionStorage.setItem('studentCode', this.editor.getValue())
        // this.check = 'teacher'
        // this.n = 'zore'
        let teacherCode = sessionStorage.getItem('teacherCode')
        this.editor.setValue(teacherCode)
      } else {
        sessionStorage.setItem('teacherCode', this.editor.getValue())
        let studentCode = sessionStorage.getItem('studentCode')
        // if (this.check != 'live' && this.n != 'one') {
          this.editor.setValue(studentCode)
        //   this.n = 'one'
        // }
        // this.check = 'live'
      }
    }
  }
}
</script>

<style lang="scss">
  .anchor{
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    .dragWrap{
      position: relative;
      width: 100%;
      height: calc(100% - 48px);
      overflow: hidden;
    }
    .editor, .iterm-wrap{
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// anchor.vue?40815502